import classnames from 'classnames';
import React from 'react';

export default function FooterWrapper({ children, className }) {
  return <div className={classnames('py-sm bg-gray-100', className)}>{children}</div>;
}
